import React from 'react'
import {randomNum, calculateWidth} from '../../utils/utils'
import {withRouter} from 'react-router-dom'
import {inject, observer} from 'mobx-react/index'
import {Form, Input, Select, Col,message,Checkbox} from 'antd'
import PromptBox from '../../components/PromptBox'
import {doHttpAjax} from '../../components/DoAjax/doAjax'
import {getTicket, setTicket, setCookie, getCookie} from '../../utils/Session'
import * as HttpUtils from '../../components/DoFetch/doFetch'
const {Option} = Select;
@withRouter @inject('appStore') @observer @Form.create()
class LoginForm extends React.Component {
    state = {
        focusItem: -1,   //保存当前聚焦的input
        code: '',         //验证码
        keep:false
    }

    componentDidMount() {
        console.log(getCookie('keep'))
        // if (getCookie('keep') == 1) {
        //     this.setState({
        //         keep: true
        //     })
        //     this.props.form.setFieldsValue({username: getCookie('account')})
        //     this.props.form.setFieldsValue({password: getCookie('password')})
        //     console.log(this.state.keep)
        // } else {
        //     this.setState({
        //         keep: false
        //     })
        //     this.props.form.setFieldsValue({username: ''})
        //     this.props.form.setFieldsValue({password: ''})
        // }
    }

    /**
     * 生成验证码
     */

    loginSubmit = (e) => {
        e.preventDefault()
        this.setState({
            focusItem: -1
        })
        this.props.form.validateFields((err, values) => {
            console.log(err)
            console.log(values)
            let that = this;
            if (!err) {
                let url = "/boss/agentLogin";
                let data = {
                    account: values.username,
                    password: values.password,
                    validCode: values.validcode
                };
                let success = (res) => {
                    console.log(res)
                    setTicket(res.data.ticket)
                    setCookie("spreaderId", res.data.userId);
                    that.props.appStore.toggleLogin(true, {username: values.username})
                    const {from} = that.props.location.state || {from: {pathname: '/'}}
                    that.props.history.push(from)
                };
                let failBack = (res) => {
                    if(res.code=='login.account.password.wrong'){
                        return message.error('用户名或密码不正确')
                    }
                    if(res.code=='user.not.exist'){
                        return message.error('用户不存在')
                    }
                };
                HttpUtils.doPost(this, url, data, success, failBack);
            }
        })
    }
    register = () => {
        this.props.switchShowBox('register')
        setTimeout(() => this.props.form.resetFields(), 500)
    }
    onCheckChange = (e) => {
        console.log(`checked = ${e.target.checked}`);
        this.setState({
            keep: e.target.checked
        })
    }
    render() {
        const {getFieldDecorator, getFieldError} = this.props.form
        const {focusItem, code} = this.state
        return (
            <div id="login">
                <div className="rightContainer">
                    <div className='title'>代理后台</div>
                    <Form onSubmit={this.loginSubmit}>

                        <Form.Item help={getFieldError('username') &&
                        <PromptBox info={getFieldError('username')} width={calculateWidth(getFieldError('username'))}/>}>
                            {getFieldDecorator('username', {
                                rules: [{required: true, message: '请输入用户名'}]
                            })(
                                <Input
                                    className='loginInput'
                                    onFocus={() => this.setState({focusItem: 0})}
                                    onBlur={() => this.setState({focusItem: -1})}
                                    maxLength={46}
                                    placeholder='用户名'
                                   />
                            )}
                        </Form.Item>
                        <Form.Item help={getFieldError('password') &&
                        <PromptBox info={getFieldError('password')} width={calculateWidth(getFieldError('password'))}/>}>
                            {getFieldDecorator('password', {
                                rules: [{required: true, message: '请输入密码'}]
                            })(
                                <Input
                                    className='loginInput'
                                    onFocus={() => this.setState({focusItem: 1})}
                                    onBlur={() => this.setState({focusItem: -1})}
                                    type='password'
                                    maxLength={46}
                                    placeholder='密码'
                                    />
                            )}
                        </Form.Item>

                        <Form.Item help={getFieldError('validcode') &&
                        <PromptBox info={getFieldError('validcode')} width={calculateWidth(getFieldError('validcode'))}/>}>
                            {getFieldDecorator('validcode', {
                                rules: [{required: true, message: '请输入验证码'}]
                            })(
                                <Input
                                    className='loginInput'
                                    onFocus={() => this.setState({focusItem: 2})}
                                    onBlur={() => this.setState({focusItem: -1})}
                                    type='password'
                                    maxLength={16}
                                    placeholder='验证码'
                                />
                            )}
                        </Form.Item>

                        <div className='bottom'>
                            <input className='loginBtn' type="submit" value='登录'/>
                            {/*<span className='registerBtn' onClick={this.register}>注册</span>*/}
                        </div>

                    </Form>
                </div>
            </div>

        )
    }
}

const styles = {
    focus: {
        width: '20px',
        opacity: 1
    },
}

export default LoginForm


// WEBPACK FOOTER //
// ./src/routes/Login/LoginForm.js